// extracted by mini-css-extract-plugin
export var image = "ArtificialIntelligence-module--image--9910b";
export var list = "ArtificialIntelligence-module--list--25119";
export var listItem = "ArtificialIntelligence-module--list-item--ee2a4";
export var typography = "ArtificialIntelligence-module--typography--d1f2a";